import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c279c14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal confirmModal noHeight p-3 text-center" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_3 = { class: "closeButton" }
const _hoisted_4 = {
  key: 0,
  class: "midTitle text-center"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "body mt-2" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "mt-3 mw-700" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fplogo = _resolveComponent("fplogo")!
  const _component_icon_close = _resolveComponent("icon-close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_fplogo, { small: true }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ko && _ctx.ko(...args)))
        }, [
          _createVNode(_component_icon_close)
        ])
      ])
    ]),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", { innerHTML: _ctx.title }, null, 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", { innerHTML: _ctx.text }, null, 8, _hoisted_7),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-block noShadow btn-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
          }, [
            _createElementVNode("span", { innerHTML: _ctx.okText }, null, 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-block noShadow btn-danger",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ko && _ctx.ko(...args)))
          }, [
            _createElementVNode("span", { innerHTML: _ctx.koText }, null, 8, _hoisted_11)
          ])
        ])
      ])
    ])
  ]))
}